<template>
    <div class="production-container">
        <!-- 焊接规范号选择 -->
        <Card class="card-container" dis-hover>
            <div slot="title" class="card-title">规范</div>
            <div>
                <fieldset class="my-fieldset ">
                    <legend class="my-legend">规范描述</legend>
                    <Row type="flex">
                        <Col flex="1">
                        <label class="select-label">规范号：</label>
                        </Col>
                        <Col flex="1">
                        <Select v-model="programData.WeldID" size="small" :loading="selectLoading" @on-change="onWeldIDChange" :placeholder="getTranslation('m034')">
                            <Option v-for="i in 100" :value="i-1" :key="i-1">{{ i-1 }}</Option>
                        </Select>
                        
                        
                        </Col>
                        <Col flex="1">
                            <Button type="primary" >复制</Button>
                        </Col>

                        <Col flex="1">
                        <label class="select-label">工作型号：</label>
                        </Col>
                        <Col flex="1">
                        <Input size="small" v-model="programData.TxtPartModel" />
                        </Col>
                        <Col flex="1">
                        <label class="select-label">物料条码：</label>
                        </Col>
                        <Col flex="1">
                        <Input size="small" v-model="programData.TxtMatCode" />
                        </Col>
                    </Row>
                </fieldset>
            </div>
            <div>
                <fieldset class="my-fieldset ">
                    <legend class="my-legend">送料</legend>
                    <Row type="flex">
                        <Col flex="1">
                        <label class="select-label">预送料：</label>
                        </Col>
                        <Col flex="1">
                        <i-switch class="switch-cls" size="small" :true-value="1" :false-value="0" v-model="CfgAuxbit1"></i-switch>
                        </Col>
                        <Col flex="4">
                        </Col>
                    </Row>
                    <Row type="flex">
                        <Col flex="1">
                        <label class="select-label">输送机选择</label>
                        </Col>
                        <Col flex="1">
                        <Select v-model="programData.OptConv" size="small" :placeholder="getTranslation('m034')">
                            <Option v-for="(item, key) in OptConvList" :value="key" :key="key">{{ item }}</Option>
                        </Select>
                        </Col>
                        <Col flex="1">
                        <label class="select-label">输送物料</label>
                        </Col>
                        <Col flex="1">
                        <Select v-model="InfoConvbit1" size="small">
                            <Option v-for="(item, key) in HwConvTypeMatList" :value="key" :key="key">{{ item }}</Option>
                        </Select>
                        </Col>
                        <Col flex="1">
                        <label class="select-label">输送方向</label>
                        </Col>
                        <Col flex="1">
                        <Select v-model="InfoConvbit2" size="small">
                            <Option v-for="(item, key) in HwConvTypeDirList" :value="key" :key="key">{{ item }}</Option>
                        </Select>
                        </Col>
                        <Col flex="1">
                        <label class="select-label">送料方式</label>
                        </Col>
                        <Col flex="1">
                        <Select v-model="InfoConvbit0" size="small">
                            <Option v-for="(item, key) in HwConvTypeList" :value="key" :key="key">{{ item }}</Option>
                        </Select>
                        </Col>

                    </Row>
                </fieldset>
            </div>
            <div>
                <fieldset class="my-fieldset ">
                    <legend class="my-legend">焊接</legend>
                    <Row type="flex">
                        <Col flex="1">
                        <fieldset class="my-fieldset ">
                            <legend class="my-legend">预压</legend>
                            <Row type="flex">
                                <Col flex="1">预压压力</Col>
                                <Col flex="1">
                                <InputNumber size="small" type="number" v-model="programData.PrsPre" />
                                </Col>
                            </Row>
                            <Row type="flex">
                                <Col flex="1">预压时间</Col>
                                <Col flex="1">
                                <InputNumber size="small" type="number" v-model="programData.TmPre" />
                                </Col>
                            </Row>
                        </fieldset>
                        </Col>
                        <Col flex="1">
                        <fieldset class="my-fieldset ">
                            <legend class="my-legend">加压</legend>
                            <Row type="flex">
                                <Col flex="1">倍力</Col>
                                <Col flex="1">
                                <i-switch class="switch-cls" size="small" :true-value="1" :false-value="0" v-model="CfgAuxbit2"></i-switch>
                                </Col>
                            </Row>
                            <Row type="flex">
                                <Col flex="1">加压压力</Col>
                                <Col flex="1">
                                <InputNumber size="small" type="number" v-model="programData.PrsMain" />
                                </Col>
                            </Row>
                            <Row type="flex">
                                <Col flex="1">加压时间</Col>
                                <Col flex="1">
                                <InputNumber size="small" type="number" v-model="programData.TmMain" />
                                </Col>
                            </Row>
                        </fieldset>
                        </Col>
                        <Col flex="1">
                        <fieldset class="my-fieldset ">
                            <legend class="my-legend">放电</legend>

                        </fieldset>
                        </Col>

                        <Col flex="1">
                        <fieldset class="my-fieldset ">
                            <legend class="my-legend">保压</legend>
                            <Row type="flex">
                                <Col flex="1">时间</Col>
                                <Col flex="1">
                                <InputNumber size="small" type="number" v-model="programData.TmHold" />
                                </Col>
                            </Row>
                        </fieldset>
                        </Col>

                        <Col flex="1">
                        <fieldset class="my-fieldset ">
                            <legend class="my-legend">回程</legend>
                            <Row type="flex">
                                <Col flex="1">压力</Col>
                                <Col flex="1">
                                <InputNumber size="small" type="number" v-model="programData.PrsRet" />
                                </Col>
                            </Row>
                            <Row type="flex">
                                <Col flex="1">行程</Col>
                                <Col flex="1">
                                <Select v-model="CfgAuxbit3" size="small">
                                    <Option v-for="(item, key) in CfgAuxbit3List" :value="key" :key="key">{{ item }}</Option>
                                </Select> </Col>
                            </Row>
                        </fieldset>
                        </Col>

                    </Row>
                </fieldset>
            </div>
             <div>
                <fieldset class="my-fieldset ">
                    <legend class="my-legend">质量测试</legend>
                    <Row type="flex">
                        <Col flex="1">
                        <fieldset class="my-fieldset ">
                            <legend class="my-legend">熔限值监测</legend>
                            <Row type="flex">
                                <Col flex="1">熔限值上限</Col>
                                <Col flex="1">
                                <InputNumber size="small" type="number" v-model="programData.IThrMeltUp" />
                                </Col>
                            </Row>
                            <Row type="flex">
                                <Col flex="1">熔限值下限</Col>
                                <Col flex="1">
                                <InputNumber size="small" type="number" v-model="programData.IThrMeltLow" />
                                </Col>
                            </Row>
                        </fieldset>
                        </Col>
                        <Col flex="1">
                        <fieldset class="my-fieldset ">
                            <legend class="my-legend">螺母/栓防错监测</legend>
                            <Row type="flex">
                                <Col flex="1">动电极</Col>
                                <Col flex="1">
                                </Col>
                                <Col flex="1">定位销</Col>
                                <Col flex="1">
                                </Col>
                            </Row>
                            <Row type="flex">
                                <Col flex="1">录入位移</Col>
                                <Col flex="1">
                                <InputNumber size="small" type="number" v-model="programData.IPosNutMovLoad" />
                                </Col>
                                <Col flex="1">录入位移</Col>
                                <Col flex="1">
                                <InputNumber size="small" type="number" v-model="programData.IPosNutFixPinLoad" />
                                </Col>
                            </Row>
                            <Row type="flex">
                                <Col flex="1">允许上偏差</Col>
                                <Col flex="1">
                                <InputNumber size="small" type="number" v-model="programData.ITolNutMovUp" />
                                </Col>
                                <Col flex="1">允许上偏差</Col>
                                <Col flex="1">
                                <InputNumber size="small" type="number" v-model="programData.ITolNutFixPinUp" />
                                </Col>
                            </Row>
                            <Row type="flex">
                                <Col flex="1">允许上偏差</Col>
                                <Col flex="1">
                                <InputNumber size="small" type="number" v-model="programData.ITolNutMovLow" />
                                </Col>
                                <Col flex="1">允许上偏差</Col>
                                <Col flex="1">
                                <InputNumber size="small" type="number" v-model="programData.ITolNutFixPinLow" />
                                </Col>
                            </Row>
                            <Row type="flex"><Col flex="1"><Button type="primary" >螺母/栓位置录</Button></Col></Row>

                        </fieldset>
                        </Col>


                    </Row>
                </fieldset>
            </div>
            <Row type="flex" class="flex-middle">
                <Col flex="1">
                <Button type="primary" @click="handleSave">{{ getTranslation('c006') }}</Button>
                </Col>
            </Row>
        </Card>
    </div>
</template>

<script>
import {
    API_URL
} from '@/constants/const'
import axios from 'axios'
import {
    postJsError,
    int16toBit,
    bitToInt16
} from '@/util/util'
import {
    mapGetters
} from 'vuex'


export default {
    name: 'SpecSetting',
    props: {
        mac: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            loading: false,
            selectLoading: false,
            selectedWeldID: 0,
            programData: {},
            bitFields: ['CfgAux', 'InfoConv'],
            // 原始值快照，保存时对比用
            originalData: {},
            // { HwAssy0: [0,1,0,...], HwAssy1: [...] }
            localBitsMap: {},
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),
        CfgAuxbit1: {
            get: function () {
                var b = this.localBitsMap['CfgAux'];
                return b ? b[1] : 0
            },
            set: function (val) {
                var b = this.localBitsMap['CfgAux'];
                if (b) this.$set(b, 1, val ? 1 : 0)
            }
        },
        CfgAuxbit2: {
            get: function () {
                var b = this.localBitsMap['CfgAux'];
                return b ? b[2] : 0
            },
            set: function (val) {
                var b = this.localBitsMap['CfgAux'];
                if (b) this.$set(b, 2, val ? 1 : 0)
            }
        },
        CfgAuxbit3: {
            get: function () {
                var b = this.localBitsMap['CfgAux'];
                return b ? b[3] : 0
            },
            set: function (val) {
                var b = this.localBitsMap['CfgAux'];
                if (b) this.$set(b, 3, val ? 1 : 0)
            }
        },
        InfoConvbit0: {
            get: function () {
                var b = this.localBitsMap['InfoConv'];
                return b ? b[0] : 0
            },
            set: function (val) {
                var b = this.localBitsMap['InfoConv'];
                if (b) this.$set(b, 0, val ? 1 : 0)
            }
        },
        InfoConvbit1: {
            get: function () {
                var b = this.localBitsMap['InfoConv'];
                return b ? b[1] : 0
            },
            set: function (val) {
                var b = this.localBitsMap['InfoConv'];
                if (b) this.$set(b, 1, val ? 1 : 0)
            }
        },
        InfoConvbit2: {
            get: function () {
                var b = this.localBitsMap['InfoConv'];
                return b ? b[2] : 0
            },
            set: function (val) {
                var b = this.localBitsMap['InfoConv'];
                if (b) this.$set(b, 2, val ? 1 : 0)
            }
        },

        OptConvList() {
            return [
                "无输送机",
                "1号输送机",
                "2号输送机",
            ]
        },
        HwConvTypeList() {
            return [
                this.getTranslation('a169'),
                this.getTranslation('a170'),
            ]
        },
        HwConvTypeDirList() {
            return [
                this.getTranslation('a171'),
                this.getTranslation('a172'),
            ]
        },
        HwConvTypeMatList() {
            return [
                this.getTranslation('a173'),
                this.getTranslation('a174'),
            ]
        },
        CfgAuxbit3List(){
             return [
                "大张开",
                "小张开",
            ]
        }
    },
    created() {
        this.initBits();
        this.readProgram()
    },
    methods: {
        initBits() {
            let self = this;
            this.bitFields.forEach(function (field) {
                self.$watch('programData.' + field, function (newVal) {
                    if (newVal != null) {
                        self.$set(self.localBitsMap, field, int16toBit(newVal))
                        self.$set(self.originalData, field, newVal)
                    }
                }, {
                    immediate: true
                })
            })
        },
        // 初始加载：读取当前设备规范
        async readProgram() {
            this.loading = true
            const url = API_URL['501ProgramGet']
            const params = {
                mac: this.mac
            }
            try {
                const res = await axios.get(url, {
                    params
                })
                if (res && res.data && res.data.code == 200) {
                    if (res.data.data && res.data.data.program) {
                        this.applyProgramData(res.data.data.program)
                    }
                } else if (res && res.data && res.data.msg) {
                    this.$Message.error(res.data.msg)
                } else {
                    this.$Message.error(this.getTranslation('c001'))
                }
            } catch (err) {
                postJsError(err)
                this.$Message.error(this.getTranslation('c001'))
            } finally {
                this.loading = false
            }
        },

        // 规范号下拉变化：先单独写规范号地址，再重新读取全部数据
        async onWeldIDChange(weldId) {
            this.selectLoading = true
            const url = API_URL['501ProgramSelect']
            const params = {
                mac: this.mac,
                weldId: weldId
            }
            try {
                const res = await axios.post(url, null, {
                    params
                })
                if (res && res.data && res.data.code == 200) {
                    if (res.data.data && res.data.data.program) {
                        this.applyProgramData(res.data.data.program)
                    }
                } else if (res && res.data && res.data.msg) {
                    this.$Message.error(res.data.msg)
                } else {
                    this.$Message.error(this.getTranslation('c001'))
                }
            } catch (err) {
                postJsError(err)
                this.$Message.error(this.getTranslation('c001'))
            } finally {
                this.selectLoading = false
            }
        },

        // 将服务端返回的 program 数据填充到页面
        applyProgramData(prog) {
            for (var f in prog) {
                this.$set(this.programData, f, prog[f] != null ? prog[f] : 0)
            }
        },
        async handleSave() {
            var self = this
            this.bitFields.forEach(function (field) {
                var bits = self.localBitsMap[field]
                if (!bits) return
                var newVal = bitToInt16(bits)
                if (newVal !== self.originalData[field]) {
                    self.programData[field] = newVal
                }
            })

            let formData = new FormData();
            formData.append('mac', this.mac);
            formData.append('param', JSON.stringify(this.programData));
            var res = await axios.post(API_URL['501ProgramDownload'], formData).catch((err) => {
                postJsError(err)
                this.$Message.error(this.getTranslation('c001'))
            })
            if (res && res.data && res.data.code == 200) {
                this.$Message.success(res.data.msg)
                this.initBits()
            } else if (res && res.data && res.data.msg) {
                this.$Message.error(res.data.msg)
            } else {
                this.$Message.error(this.getTranslation('c001'))
            }

        }
    }
}
</script>

<style scoped>
@import url('../../../../assets/style/list.css');
@import url('../../../../assets/style/tab.css');

.production-container {
    padding: 10px;
}

.card-container {
    margin-bottom: 12px;
}

.card-title {
    font-weight: bold;
    font-size: 14px;
}

.select-label {
    font-size: 13px;
    line-height: 32px;
}

.field-item {
    margin-bottom: 8px;
}

.field-label {
    display: block;
    font-size: 12px;
    color: #666;
    margin-bottom: 3px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
